module.exports = __webpack_public_path__ + "static/media/pedidos.864efb45.svg";